import { ReactNode } from 'react';

interface PreviewCardProps {
  title: string;
  subTitle: string;
  /** A compact tile with an accent edge, for a single number. Charts get the full width. */
  tile?: boolean;
  children: ReactNode;
}

// A dashboard widget: the title (cut off when long, as on a dashboard card) and subtitle, then the chart or number.
export const PreviewCard = ({ title, subTitle, tile = false, children }: PreviewCardProps) => (
  <div className={tile ? 'col-12 col-md-8 col-xl-6 px-0' : ''}>
    <div className={`card shadow-sm ${tile ? 'border-0 border-start border-4 border-primary' : ''}`}>
      <div className="card-body">
        <div className="fw-semibold text-truncate" title={title}>{title || 'Untitled visualization'}</div>
        {subTitle && <div className="small text-secondary text-truncate" title={subTitle}>{subTitle}</div>}
        <div className="mt-3">{children}</div>
      </div>
    </div>
  </div>
);
